/**
 * Novelarc 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Novelarc 品牌特定主题配置
 */
export const theme = {
  // 头像边框色 (Novelarc 使用 #FFF4ED)
  avatarBorder: '#FFF4ED',
  // 按钮背景色 (Novelarc 使用 #FFF4ED)
  btnPrimaryBg: '#FFF4ED',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/novelarc/member_subscribe_bg.webp)',
} as const

/**
 * Novelarc 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/novelarc/member-bg.webp',
  // 用户背景图
  userBg: '/images/novelarc/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/novelarc/user-default.png',
  // VIP 图标
  memberVip: '/images/novelarc/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/novelarc/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
